module.exports = __webpack_public_path__ + "img/4.2eeb46fd.jpg";